import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionMarkIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 7.50001C7.50009 7.0417 7.62616 6.59224 7.86443 6.20074C8.10271 5.80924 8.444 5.49077 8.85108 5.28014C9.25808 5.06951 9.71525 4.97483 10.1724 5.00644C10.6297 5.03805 11.0694 5.19474 11.4436 5.45939C11.8177 5.72403 12.112 6.08644 12.2941 6.507C12.4762 6.92757 12.5393 7.39011 12.4763 7.84407C12.4133 8.29803 12.2267 8.72598 11.937 9.08106C11.6472 9.43614 11.2654 9.70473 10.8333 9.85748C10.5895 9.94373 10.3784 10.1034 10.2292 10.3146C10.0799 10.5258 9.99983 10.7781 10 11.0366V11.25",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 14.375C9.82742 14.375 9.6875 14.2351 9.6875 14.0625C9.6875 13.8899 9.82742 13.75 10 13.75",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 14.375C10.1726 14.375 10.3125 14.2351 10.3125 14.0625C10.3125 13.8899 10.1726 13.75 10 13.75",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.125 0.625H1.875C1.18464 0.625 0.625 1.18464 0.625 1.875V18.125C0.625 18.8153 1.18464 19.375 1.875 19.375H18.125C18.8153 19.375 19.375 18.8153 19.375 18.125V1.875C19.375 1.18464 18.8153 0.625 18.125 0.625Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgQuestionMarkIcon;
